import { create } from "zustand";
import type { Progress } from "@/domain/progress/model/progress";
import { createProgress } from "@/domain/progress/model/progress";

/**
 * 到達状況とスタンプを保持するストア。合格・スタンプ獲得時のみ更新される。
 *
 * NFR-002 のための規則: 利用側はストア全体ではなくセレクタで必要な値のみを購読すること
 * （このストアの更新はキー入力経路でレベル選択画面の再描画を誘発しない設計を守るため）。
 */
export interface ProgressStore {
  readonly progress: Progress;
  readonly setProgress: (progress: Progress) => void;
}

export const useProgressStore = create<ProgressStore>((set) => ({
  progress: createProgress(),
  setProgress: (progress) => set({ progress }),
}));
